import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  tr: {
    nav_about: "Hakkımızda",
    nav_products: "Ürünler",
    nav_services: "Hizmetler",
    nav_partners: "Partnerler",
    nav_contact: "İletişim",
    nav_admin: "Yönetim",
    hero_overline: "ULUSLARARASI TİCARET & LOJİSTİK",
    hero_line1: "ORTA ASYA'YA",
    hero_line2: "DÜNYA STANDARTLARINDA",
    hero_line3: "TEDARİK",
    hero_sub: "DMD GROUP INT., Çin ve Uzak Doğu'dan Orta Asya pazarına — Türkmenistan ve Özbekistan başta olmak üzere — endüstriyel hammadde ve gıda ürünleri tedarik eder. Demir yolu, kara yolu ve deniz yolu ile kesintisiz lojistik ve transit ticaret.",
    hero_cta: "Teklif Alın",
    hero_cta2: "Ürünleri Keşfet",
    stats_countries: "Hizmet Verilen Pazar",
    stats_categories: "Kuruluş Yılı",
    stats_modes: "Taşımacılık Modu",
    stats_partners: "Global Partner",
    manifesto_overline: "(MANİFESTO)",
    manifesto_title: "Sınırların ötesinde güvenilir ticaret",
    ch1_t: "Tedarik",
    ch1_d: "Uluslararası üreticilerden doğrudan, rekabetçi ve kaliteli ürün tedariki sağlıyoruz.",
    ch2_t: "Lojistik",
    ch2_d: "Demir yolu, kara yolu ve deniz yolu ağımızla ürünleri güvenle Orta Asya'ya ulaştırıyoruz.",
    ch3_t: "Güven",
    ch3_d: "Wankai ve Angel Yeast gibi global markalarla kurduğumuz partnerliklerle güven inşa ediyoruz.",
    products_overline: "(ÜRÜN GRUPLARI)",
    products_title: "Tedarik ettiğimiz ürünler",
    cat_all: "Tümü",
    cat_construction: "İnşaat Malzemeleri",
    cat_raw: "Hammadde",
    cat_food: "Gıda Ürünleri",
    cat_spices: "Baharat",
    routes_title: "Aktif Taşıma Rotaları",
    routes_sub: "Çin ve Körfez'den Orta Asya'ya uçtan uca koridorlar.",
    offices_title: "Temsilcilik Ofisleri",
    story_overline: "(TARİHÇE)",
    story_title: "2018'den bu yana güvenilir transit ticaret",
    story_body: "DMD GROUP INT., 2018 yılından bu yana Türkiye merkezli olarak ihracat ve uluslararası transit ticaret faaliyetleri yürütmektedir. Çin ve Uzak Doğu ülkelerinden yaptığımız ürün tedariği ile Orta Asya pazarına — başta Türkmenistan ve Özbekistan olmak üzere — kesintisiz hizmet sunuyoruz. Geniş lojistik ağımız sayesinde uluslararası sevkiyatlarınız için hızlı, güvenilir ve ekonomik çözümler üretiyoruz.",
    story_tagline: "Tedarik süreçleriniz için en hızlı ve en uygun maliyetli rota ve teslimat.",
    markets_label: "HİZMET VERİLEN PAZARLAR",
    services_overline: "(HİZMETLER)",
    services_title: "Çok modlu taşımacılık",
    svc_rail_t: "Demir Yolu",
    svc_rail_d: "Orta Asya demir yolu ağı üzerinden yüksek hacimli, ekonomik ve güvenilir konteyner taşımacılığı.",
    svc_road_t: "Kara Yolu",
    svc_road_d: "Kapıdan kapıya esnek karayolu taşımacılığı ile hızlı teslimat çözümleri.",
    svc_sea_t: "Deniz Yolu",
    svc_sea_d: "Konteyner ve dökme yük için global limanlardan deniz yolu taşımacılığı.",
    partners_overline: "(PARTNERLER)",
    partners_title: "Global iş ortaklarımız",
    contact_overline: "(İLETİŞİM)",
    contact_title: "Bir teklif mi istiyorsunuz?",
    contact_sub: "Formu doldurun, ekibimiz en kısa sürede sizinle iletişime geçsin.",
    f_name: "Ad Soyad",
    f_email: "E-posta",
    f_company: "Şirket",
    f_phone: "Telefon",
    f_message: "Mesajınız",
    f_send: "Talebi Gönder",
    f_sending: "Gönderiliyor...",
    f_success: "Talebiniz alındı. En kısa sürede dönüş yapacağız.",
    f_error: "Bir hata oluştu. Lütfen tekrar deneyin.",
    footer_tagline: "Orta Asya pazarına uluslararası tedarik.",
    footer_rights: "Tüm hakları saklıdır.",
    view: "İncele",
  },
  en: {
    nav_about: "About",
    nav_products: "Products",
    nav_services: "Services",
    nav_partners: "Partners",
    nav_contact: "Contact",
    nav_admin: "Admin",
    hero_overline: "INTERNATIONAL TRADE & LOGISTICS",
    hero_line1: "WORLD-CLASS",
    hero_line2: "SUPPLY TO",
    hero_line3: "CENTRAL ASIA",
    hero_sub: "DMD GROUP INT. sources industrial raw materials and food products from China and the Far East into the Central Asian market — primarily Turkmenistan and Uzbekistan. Seamless logistics and transit trade by rail, road and sea.",
    hero_cta: "Get a Quote",
    hero_cta2: "Explore Products",
    stats_countries: "Markets Served",
    stats_categories: "Established",
    stats_modes: "Transport Modes",
    stats_partners: "Global Partners",
    manifesto_overline: "(MANIFESTO)",
    manifesto_title: "Trusted trade beyond borders",
    ch1_t: "Sourcing",
    ch1_d: "We source competitive, high-quality products directly from international manufacturers.",
    ch2_t: "Logistics",
    ch2_d: "We move goods safely to Central Asia via our rail, road and sea network.",
    ch3_t: "Trust",
    ch3_d: "We build trust through partnerships with global brands like Wankai and Angel Yeast.",
    products_overline: "(PRODUCT GROUPS)",
    products_title: "Products we supply",
    cat_all: "All",
    cat_construction: "Construction",
    cat_raw: "Raw Materials",
    cat_food: "Food Products",
    cat_spices: "Spices",
    routes_title: "Active Transport Routes",
    routes_sub: "End-to-end corridors from China and the Gulf into Central Asia.",
    offices_title: "Representative Offices",
    story_overline: "(OUR STORY)",
    story_title: "Trusted transit trade since 2018",
    story_body: "Since 2018, DMD GROUP INT. has carried out export and international transit-trade operations based in Türkiye. By sourcing products from China and the Far East, we serve the Central Asian market — primarily Turkmenistan and Uzbekistan — without interruption. Through our extensive logistics network, we deliver fast, reliable and cost-effective solutions for your international shipments.",
    story_tagline: "Providing the fastest and most affordable routes and delivery for your procurements.",
    markets_label: "MARKETS SERVED",
    services_overline: "(SERVICES)",
    services_title: "Multimodal transport",
    svc_rail_t: "Railway",
    svc_rail_d: "High-volume, economical and reliable transport across the Central Asian rail network.",
    svc_road_t: "Road",
    svc_road_d: "Flexible door-to-door road freight for fast delivery solutions.",
    svc_sea_t: "Sea",
    svc_sea_d: "Sea freight for containers and bulk cargo from global ports.",
    partners_overline: "(PARTNERS)",
    partners_title: "Our global partners",
    contact_overline: "(CONTACT)",
    contact_title: "Want a quote?",
    contact_sub: "Fill in the form and our team will get back to you shortly.",
    f_name: "Full Name",
    f_email: "Email",
    f_company: "Company",
    f_phone: "Phone",
    f_message: "Your message",
    f_send: "Send Inquiry",
    f_sending: "Sending...",
    f_success: "Your inquiry has been received. We will get back to you soon.",
    f_error: "An error occurred. Please try again.",
    footer_tagline: "International supply to the Central Asian market.",
    footer_rights: "All rights reserved.",
    view: "View",
  },
  ru: {
    nav_about: "О нас",
    nav_products: "Продукция",
    nav_services: "Услуги",
    nav_partners: "Партнёры",
    nav_contact: "Контакты",
    nav_admin: "Админ",
    hero_overline: "МЕЖДУНАРОДНАЯ ТОРГОВЛЯ И ЛОГИСТИКА",
    hero_line1: "МИРОВЫЕ",
    hero_line2: "ПОСТАВКИ В",
    hero_line3: "ЦЕНТРАЛЬНУЮ АЗИЮ",
    hero_sub: "DMD GROUP INT. поставляет промышленное сырьё и продукты питания из Китая и Дальнего Востока на рынок Центральной Азии — прежде всего в Туркменистан и Узбекистан. Бесшовная логистика и транзитная торговля по железной дороге, автодорогам и морю.",
    hero_cta: "Получить расчёт",
    hero_cta2: "Смотреть продукцию",
    stats_countries: "Обслуживаемые рынки",
    stats_categories: "Год основания",
    stats_modes: "Виды транспорта",
    stats_partners: "Глобальные партнёры",
    manifesto_overline: "(МАНИФЕСТ)",
    manifesto_title: "Надёжная торговля без границ",
    ch1_t: "Закупка",
    ch1_d: "Мы закупаем конкурентную и качественную продукцию напрямую у международных производителей.",
    ch2_t: "Логистика",
    ch2_d: "Мы безопасно доставляем товары в Центральную Азию по железной дороге, автодорогам и морю.",
    ch3_t: "Доверие",
    ch3_d: "Мы строим доверие через партнёрство с такими брендами, как Wankai и Angel Yeast.",
    products_overline: "(ГРУППЫ ТОВАРОВ)",
    products_title: "Поставляемая продукция",
    cat_all: "Все",
    cat_construction: "Стройматериалы",
    cat_raw: "Сырьё",
    cat_food: "Продукты питания",
    cat_spices: "Специи",
    routes_title: "Действующие маршруты",
    routes_sub: "Сквозные коридоры из Китая и Залива в Центральную Азию.",
    offices_title: "Представительства",
    story_overline: "(О НАС)",
    story_title: "Надёжная транзитная торговля с 2018 года",
    story_body: "С 2018 года компания DMD GROUP INT. осуществляет экспортную и международную транзитную торговлю из Турции. Закупая товары в Китае и странах Дальнего Востока, мы бесперебойно обслуживаем рынок Центральной Азии — прежде всего Туркменистан и Узбекистан. Благодаря широкой логистической сети мы предлагаем быстрые, надёжные и экономичные решения для ваших международных перевозок.",
    story_tagline: "Самые быстрые и выгодные маршруты и доставка для ваших закупок.",
    markets_label: "ОБСЛУЖИВАЕМЫЕ РЫНКИ",
    services_overline: "(УСЛУГИ)",
    services_title: "Мультимодальные перевозки",
    svc_rail_t: "Железная дорога",
    svc_rail_d: "Крупнообъёмные, экономичные и надёжные контейнерные перевозки по железнодорожной сети Центральной Азии.",
    svc_road_t: "Автодороги",
    svc_road_d: "Гибкие автоперевозки «от двери до двери» для быстрой доставки.",
    svc_sea_t: "Море",
    svc_sea_d: "Морские перевозки контейнеров и насыпных грузов из мировых портов.",
    partners_overline: "(ПАРТНЁРЫ)",
    partners_title: "Наши глобальные партнёры",
    contact_overline: "(КОНТАКТЫ)",
    contact_title: "Нужен расчёт?",
    contact_sub: "Заполните форму, и наша команда свяжется с вами в ближайшее время.",
    f_name: "Имя и фамилия",
    f_email: "Эл. почта",
    f_company: "Компания",
    f_phone: "Телефон",
    f_message: "Ваше сообщение",
    f_send: "Отправить запрос",
    f_sending: "Отправка...",
    f_success: "Ваш запрос получен. Мы скоро свяжемся с вами.",
    f_error: "Произошла ошибка. Пожалуйста, попробуйте снова.",
    footer_tagline: "Международные поставки на рынок Центральной Азии.",
    footer_rights: "Все права защищены.",
    view: "Смотреть",
  },
};

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("dmd_lang") || "tr");
  useEffect(() => {
    localStorage.setItem("dmd_lang", lang);
  }, [lang]);
  const t = (key) => (dict[lang] && dict[lang][key]) || dict.tr[key] || key;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
export const LANGS = ["tr", "en", "ru"];
